<template>
  <div class="course-dilemma">
    <h1>{{header}}</h1>
    <p>
        This is the first week of my second semester (Spring) at Texas A&M. The winds are strong and the temperature
        is low, but it is pleasant compared to other parts of the US. I stayed on campus during the winter break
        trying to do some projects. I ended up starting lots of competitions on Codalab/Kaggle and not continuing
        any of them except one. I also read a bunch of papers, that are not directly related to my research, but I
        don’t regret that. It is nice to see lots of people back in school after a month of seclusion.
    </p>
    <p>
        I’m attending lectures of three courses right now: Neural Networks (NN), Information Retrieval (IR) and
        Randomized Algorithms (RA). After this week, I will drop one of them because I’ve taken research credits
        under my professor, and I plan to focus on my research projects more. I liked all the professors and
        don’t plan to skip any lectures. NN will be taught from Francois Chollet’s book and will have homeworks
        and a final project (no exam!). I know most of the basics that will be covered, so I’m not sure if I
        should take this course. IR seems interesting, I’ve no background in the area. I’m also a grader of the
        IR undergraduate course for my professor, so taking the grad course should be helpful. RA seems the most
        challenging and mathematically heavy course, but I liked the professor a lot and his research is in
        quantum computing! I’ll think about it, I still have a week to decide.
    </p>
    <p>
        I finished the first chapter of PRML book by Bishop, which I started reading last week.
        The first chapter covers the basics of probability (sum rule, product rule, densities,
        Gaussian distribution, expectation, covariance), information theory (Entropy, KL Divergence,
        Mutual Information, Jensen’s Inequality), the curse of dimensionality, loss functions,
        Bayesian stuff (posterior, likelihood, prior, MLE, MAP) and polynomial curve fitting. I liked the
        story format of the book and the way they explain the curse of dimensionality. It also had exercises
        in between which was fun to do on my own. I want to read more textbooks than fiction/non-fiction
        books, I feel like I tend to learn more from them and will be very helpful for my work.
    </p>
    <p>
        I’m also doing the deep RL course by Sergey Levine and taking notes of that. I’ve finished till
        lecture 5 and the course has covered imitation learning, RL basics (Markov chain, MDP, POMDP,
        reward function etc.) and policy gradients. Maybe I’ll put up notes on this site but the only
        problem is that it takes a bit of time to do all this. Moreover, taking notes of online lectures
        tend to be very slow as I end up pausing the lectures multiple times.
    </p>
  </div>
</template>

<script>
export default {
  props: ["header"]
};
</script>
